import React, {Component} from 'react';
import {message, Modal, Slider, Spin} from "antd";
import playPic from "../../../mediaRelease/image/sanjiaoxing.png";
import moment from "moment";
import videojs from "video.js";
import BaseComponent from "../../../../base/BaseComponent";
import {Scrollbars} from "react-custom-scrollbars";

export default class VideoCapture extends BaseComponent {
    static defaultProps = {
        videoAll: [],
        onOk: () => {
        }
    };
    static propTypes = {};

    constructor(props) {
        super(props);
        this.state = {
            videoVisible: false,
            videoOption: {
                autoplay: false,//播放器准备好之后，是否自动播放 【默认false】
                loop: false, //视频播放结束后，是否循环播放
                controls: true,
                responsive: true,
                fluid: true,
                muted: false,//是否静音
                width: 480,
                height: 270,
                crossOrigin: 'anonymous',
                controlBar: {
                    fullscreenToggle: false,//显示全屏按钮，默认为true
                    pictureInPictureToggle: true,//隐藏画中画按钮，默认为true
                    volumePanel: true,//隐藏声音面板
                    currentTimeDisplay: true,//显示当前播放时间
                    timeDivider: false,//显示时间分割线
                    durationDisplay: true,//显示总时间
                    remainingTimeDisplay: true,//隐藏剩余时间，
                    audioTrackButton: true //音频跟踪按钮
                },
                sources: [{
                    src: '',
                    type: 'video/mp4'
                }],
                playbackRates: [0.5, 1, 1.5, 2],
                aspectRatio: '16:9'
            },
            body: {
                id: '',
                coverUrl: "",
                mediaId: "",
                title: "",
                videoDuration: 0,
                videoFileLen: 0,
                videoName: "",
                videoUrl: "",
                tags: []
            },
            currentCheckedVideo: '',
            videoImg: '',
            currentTime: 1,//视频取桢数
            selectVideoCover: [],
            currentChecked: false,
            checkedVideo: props.videoAll && props.videoAll[0] && props.videoAll[0].src ? props.videoAll[0].src : '',
            checkedKey: 0,
            videoAll: props.videoAll,
            videoStatus: false
        };
    }

    componentWillMount() {
        if (this.state.checkedVideo) {
            this.getVideoBase64(this.state.checkedVideo).then(res => {
                this.setState({videoImg: res})
            });
            // this.initVideo()
        }
    }

    componentWillReceiveProps(nextProps, nextContext) {
        if (nextProps.videoAll && nextProps.videoAll.length) {
            this.state.videoAll = nextProps.videoAll;
            this.state.checkedKey = 0;
            this.state.checkedVideo = nextProps.videoAll[0].src;
            this.getVideoBase64(this.state.checkedVideo).then(res => {
                this.setState({videoImg: res})
            });
            // this.initVideo()
        }
    }

    initVideo() {
        let that = this;
        if (!this.player && this.props.videoAll && this.props.videoAll[0] && this.props.videoAll[0].src) {
            this.state.videoOption.sources[0].src = this.props.videoAll[0].src;
            //创建视频区域
            this.player = videojs(that.videoNode, that.state.videoOption, function onPlayerReady() {
                console.log('onPlayerReady', this);
                that.setState({});
            });
        }
        if (this.player && this.state.videoOption.sources[0].src != this.props.videoAll[0].src) {
            this.state.videoOption.sources[0].src = this.props.videoAll[0].src;
            this.setState({}, () => {
                this.player.src({type: "video/mp4", src: this.state.videoOption.sources[0].src});
                this.player.load(this.state.videoOption.sources[0].src);
                this.player.pause();
                this.player = videojs(that.videoNode, that.state.videoOption, function onPlayerReady() {
                    console.log('onPlayerReady', this);
                    that.setState({});
                });
            })
        }
    };

    render() {
        const {videoVisible, currentTime, body, currentChecked} = this.state;
        const {videoAll} = this.props;
        console.log(videoAll);
        if (!(this.props.videoAll && this.props.videoAll.length)) return <></>;
        return (
            <Modal
                title={'视频截取'}
                centered
                width={800}
                visible={videoVisible}
                onOk={() => {
                    let file = this.getBlobBydataURI(this.state.videoImg, 'image/jpeg');
                    this.convertVideoPic(file)
                }}
                className={'videoCapture'}
                onCancel={this.handleCancelVideo}
                bodyStyle={{height: 370}}
            >
                <div style={{display: 'flex'}}>
                    <div style={{
                        // width: 225,
                        height: 370,
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'start',
                        borderRight: '2px solid #dbdbdb',
                        padding: '24px 20px 24px 32px',
                    }}>

                        <Scrollbars style={{paddingLeft: 5, width: 170}} autoHide>
                            {
                                videoAll && videoAll.map((item, index) => {
                                    return (
                                        <img src={item.videoSrc} key={index} style={{
                                            width: 160,
                                            height: 90,
                                            borderRadius: '5px',
                                            cursor: 'pointer',
                                            marginBottom: '24px',
                                            border: '1px solid',
                                            borderColor: this.state.checkedKey === index ? '#0050B3' : 'transparent',
                                        }} onClick={(e) => {
                                            this.itemVideoScreenClick(item, index);
                                        }}/>
                                    )
                                })
                            }
                        </Scrollbars>
                    </div>
                    {
                        this.state.videoStatus?
                            <Spin spinning={this.state.videoStatus} style={{display:'flex',width:574,height: 318,justifyContent:'center',alignItems:'center'}}/>:
                            <div style={{padding: '24px 47px'}}>
                                <img src={this.state.videoImg}
                                     style={{width: 480, height: 270}}/>
                                {/*视频取桢进度条*/}
                                <div style={{
                                    width: 480,
                                    height: 56,
                                    // background: 'rgba(0,0,0,0.45)',
                                    textAlign: 'center'
                                }}>
                                    <div style={{display: 'flex', paddingLeft: 5, paddingTop: 13}}>
                                        {/*<img style={{width: 9, height: 13, paddingTop: 5}} src={playPic}/>*/}
                                        <p style={{fontSize: 14}}>拖动视频帧数截取</p>
                                        {/*<div style={{color: 'white', marginLeft: 275}}>*/}
                                        {/*    <span>{moment(currentTime * 1000).format('mm:ss')}</span>/<span>{moment(this.props.videoAll[0].duration).format('mm:ss')}</span>*/}
                                        {/*</div>*/}
                                    </div>
                                    <div style={{marginTop: -16}}>
                                        <Slider
                                            value={this.state.currentTime}
                                            min={1}
                                            style={{width: '100%'}}
                                            disabled={false}
                                            max={parseInt(this.timeCycle(this.state.videoAll[this.state.checkedKey].duration))}
                                            onChange={(value) => {
                                                // console.log("value",value,this.player)
                                                this.setState({
                                                    currentTime: value
                                                }, () => {
                                                    this.getVideoBase64(this.state.checkedVideo).then(res => {
                                                        this.setState({videoImg: res})
                                                    })
                                                })
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>
                    }

                </div>
                <style>
                    {`
                    .videoCapture .ant-modal-body{
                      padding:0px !important;
                    }
                    .videoCapture .ant-slider-track{
                      background-color:#0050B3;
                    }
                    `}
                </style>
            </Modal>
        )
    }

    // 视频截取取消
    handleCancelVideo = () => {
        this.setState({videoVisible: false});
    };
    // 显示
    showModal = () => {
        this.setState({videoVisible: true});
    };
    // 视频截取
    handleVideo = () => {
        this.setState({
            videoVisible: true
        })
    };
    timeCycle = (time) => {
        if (time) {
            return time / 1000
        }
    };
    //视频封面取桢
    getVideoBase64 = (url) => {
        let {currentTime} = this.state;
        let that = this;
        return new Promise(function (resolve, reject) {
            let dataURL = '';
            let video = document.createElement("video");
            video.setAttribute('crossorigin', 'anonymous'); //处理跨域
            video.setAttribute('src', url);
            video.setAttribute('width', 400);
            video.setAttribute('height', 240);
            video.setAttribute('controls', 'controls');
            video.currentTime = currentTime;  //视频时长，一定要设置，不然大概率白屏
            that.video = video;
            video.addEventListener('loadeddata', function (e) {
                let canvas = document.createElement("canvas"),
                    width = video.width, //canvas的尺寸和图片一样
                    height = video.height;
                canvas.width = width;
                canvas.height = height;
                canvas.getContext("2d").drawImage(video, 0, 0, width, height); //绘制canvas
                dataURL = canvas.toDataURL('image/png'); //转换为base64
                var img = document.createElement("img");
                img.src = dataURL;
                video.setAttribute('poster', dataURL);
                resolve(dataURL);
            });
        })
    };

    getBlobBydataURI(dataURI, type) {
        var binary = atob(dataURI.split(',')[1]);
        var array = [];
        for (var i = 0; i < binary.length; i++) {
            array.push(binary.charCodeAt(i));
        }
        return new Blob([new Uint8Array(array)], {type: type});
        // var formData = new FormData();
        // // var frameCurrentTime = videoFrameCollect.getFrameCurrentTime();
        // // var $Blob = getBlobBydataURI(videoFrameCollect.getFrameUrl(),'image/jpeg');
        // // var isDouyin = localStorage.getItem("isDouyin")
        // formData.append(dataURI);
    }

    //视频帧封面图接口
    convertVideoPic = (file) => {
        var formData = new FormData();
        // console.log(file)
        formData.append('file', file, '未命名.png');
        // console.log(formData)
        this.request({
            url: "/storage/uploadFile",
            method: 'POST',
            body: formData,
            contentType: 'upload',
            callBack: (res) => {
                if (res) {
                    this.state.body.coverUrl = res.path;
                    this.props.getVideoPicture && this.props.getVideoPicture(res.path);
                    this.setState({videoVisible: false,})
                }
            },
            errorCallBack: (e) => {
            },
        })
    };

    itemVideoScreenClick(item, index) {
        this.setState({
            checkedKey: index,
            currentTime: 1,
            checkedVideo: item.src,
            videoStatus: true
        }, () => {
            console.log(this.timeCycle(this.state.videoAll[this.state.checkedKey].duration))
            this.getVideoBase64(this.state.checkedVideo).then(res => {
                this.setState({
                    videoImg: res,
                    videoStatus: false
                })
            });
        });
    }
}